import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M15 17h2","key":"svg-0"}],["path",{"d":"M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-14","key":"svg-1"}],["path",{"d":"M11 12h6","key":"svg-2"}],["path",{"d":"M13 7h4","key":"svg-3"}]]

const IconAlignBoxRightStretch = createReactComponent('outline', 'align-box-right-stretch', 'AlignBoxRightStretch', __iconNode);

export default IconAlignBoxRightStretch;